<template>
  <!-- src="https://picsum.photos/1920/1080?random"  dark -->
  <div>
    <TaskList />
    <TaskInfo />
    <NewTaskForm />
    <TaskSceneInfo />
  </div>
</template>
<script>
import TaskList from './Action/TaskList.vue'
import TaskSceneList from './Editor/TaskSceneList.vue'
import TaskInfo from './Action/TaskInfo.vue'
import NewTaskForm from './Action/NewTaskForm.vue'
import TaskSceneInfo from './Editor/TaskSceneInfo.vue'
import TaskEdit from './Action/TaskEdit.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    TaskList,
    TaskSceneList,
    TaskEdit,
    TaskInfo,
    TaskSceneInfo,
    NewTaskForm
  },
  computed: {
    ...mapGetters(['project'])
  },
  data() {
    return {
      tab: null,
      items: ['任务列表', '模型组合'],
      showTask: true,
      addTaskDialog: false
    }
  },
  methods: {
    handleMenuShow() {
      this.$store.dispatch('courseAndProject/handleShowMenu')
    },
    addTask() {
      this.$store.dispatch('task/reverseShowTaskAdd', true)
      this.$store.dispatch('task/setTaskInfo', {})
    },
    initEditor() {
      this.$store.dispatch('editor/reverseShowSceneEdit', true)
    }
  }
}
</script>
